import { ColorModeScript } from "@chakra-ui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import log from "loglevel";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import App from "./App";
import { AuthenticationContextProvider } from "./auth/auth";
import { BrandingContextProvider } from "./branding/BrandingContextProvider";
import { StrictMode } from "./components/StrictMode";
import { googleTagManagerId } from "./config";
import { DesktopClientProvider } from "./desktopClient";
import "./i18n";
import { OrganizationContextProvider } from "./orgs/OrganizationContextProvider";
import { queryClient } from "./queryClient";
import { CloudRenderingSessionProvider } from "./session/session";
import { store } from "./store";
import { SetSentrySession, SetSentryUser } from "./utils/sentry";

log.setLevel(import.meta.env.DEV ? log.levels.DEBUG : log.levels.ERROR);

if (googleTagManagerId) {
  TagManager.initialize({
    gtmId: googleTagManagerId,
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("No root element found");
}
const root = createRoot(rootElement);

root.render(
  <StrictMode isDisabled>
    <ColorModeScript />
    <QueryClientProvider client={queryClient}>
      <OrganizationContextProvider>
        <BrandingContextProvider>
          <AuthenticationContextProvider>
            <SetSentryUser />
            <Provider store={store}>
              <CloudRenderingSessionProvider />
              <DesktopClientProvider>
                <SetSentrySession />
                <App />
              </DesktopClientProvider>
            </Provider>
          </AuthenticationContextProvider>
        </BrandingContextProvider>
      </OrganizationContextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
